import {authenticationService} from "../AuthenticationService";
import axios from "axios";
import Config from "../../config/Config";
import {hasIchilovQuery} from "../../utils/routeUtils";

const patientApi = {
    sendQuestionnaire: async (report) => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient.profile.UserStorageID}/sendQuestionnaire`,
            report,
            requestconfig
        );
    },
    getAllAllergics: async (val) => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient.profile.UserStorageID}/getAllAllergics`,
            val,
            requestconfig
        );
    },
    getAllProducts: async (val) => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient.profile.UserStorageID}/getAllProducts`,
            val,
            requestconfig
        );
    },
    getAllData: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient.profile.UserStorageID}/getAllData`,
            requestconfig
        );
    },
    getQuestionnaire: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient.profile.UserStorageID}/getQuestionnaire`,
            requestconfig
        );
    },
    checkIfPayed: async (requestId) => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient.profile.UserStorageID}/requests/${requestId}/checkIfPayed`,
            requestconfig
        );
    },
    GenenrateTokenForTranzila: async (requestId) => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient.profile.UserStorageID}/requests/${requestId}/GenenrateTokenForTranzila`,
            requestconfig
        );
    },
    getPayment: async (formData) => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient.profile.UserStorageID}/getPayment`,
            formData,
            requestconfig
        );
    },
    uploadProfilePng: async (filesList) => {
        let formData = new FormData()
        formData.append("uploadedPatientFiles", filesList.file);

        formData.append('FileName', JSON.stringify("שם קובץ"))
        formData.append('uploadedPatientFiles',filesList.file);


        let selectedCategory= "profilePic"
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'multipart/form-data;Boundary=---WebKitFormBoundary7MA4YWxkTrZu0gW',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${filesList.UserStorageID}/selectedCategory/${selectedCategory}/uploadProfilePng`,
            formData,
            requestconfig
        );
    },

    deleteUploadedFiles: async (patient_id,fileToDelete,requestID) => {
        if (!authenticationService.currentUserValue)
            return;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient_id}/deleteUploadedFiles`,
            fileToDelete,
            requestconfig
        );
    },

    getProfilePic: async (patientID) => {
        let formData = new FormData()
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'multipart/form-data;Boundary=---WebKitFormBoundary7MA4YWxkTrZu0gW',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${patientID}/getProfilePic`,
            formData,
            requestconfig
        );
    },
    getTitrationStep: async (TitrationCode) => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient.profile.UserStorageID}/getTitrationStep`,
            TitrationCode,
            requestconfig
        );
    },

    deleteLastRequest: async (requestID) => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient.profile.UserStorageID}/deleteLastRequest`,
            {requestID:requestID},
            requestconfig
        );
    },
    getAllMedications: async (val) => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient.profile.UserStorageID}/getAllMedications`,
            val,
            requestconfig
        );
    },
    getAllCities: async (val) => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient.profile.UserStorageID}/getAllCities`,
            val,
            requestconfig
        );
    },
    getAllICDDiagnose: async (val) => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient.profile.UserStorageID}/getAllICDDiagnose`,
            val,
            requestconfig
        );
    },
    getAllFilesForms: async (val) => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient.profile.UserStorageID}/getAllFilesForms`,
            val,
            requestconfig
        );
    },
    getAllLeumitFilesForms: async (val) => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient.profile.UserStorageID}/getAllLeumitFilesForms`,
            val,
            requestconfig
        );
    },
    getAllUploadedFiles: async (patientID,requestID) => {
        let formData = new FormData()
        if (!authenticationService.currentUserValue)
            return;
        let requestconfig = {
            headers: {
                'Content-Type': 'multipart/form-data;Boundary=---WebKitFormBoundary7MA4YWxkTrZu0gW',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${patientID}/${requestID}/getAllUploadedFiles`,
            formData,
            requestconfig
        );
    },
    getAllLeumitUploadedFiles: async (patientID,requestID,Form_type_ID) => {
        let formData = new FormData()
        if (!authenticationService.currentUserValue)
            return;
        let requestconfig = {
            headers: {
                'Content-Type': 'multipart/form-data;Boundary=---WebKitFormBoundary7MA4YWxkTrZu0gW',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${patientID}/${requestID}/FormType/${Form_type_ID}/getAllLeumitUploadedFiles`,
            formData,
            requestconfig
        );
    },
    deleteLeumitUploadedFiles: async (patient_id,Form_type_ID,requestID,fileName) => {
        let formData = new FormData()
        if (!authenticationService.currentUserValue)
            return;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient_id}/${requestID}/FormType/${Form_type_ID}/deleteLeumitUploadedFiles`,
            {fileName:fileName},
            requestconfig
        );
    },
    getUploadedFile: async (filesList) => {
        let formData = new FormData()
        let file = filesList.file[0]
        formData.append("uploadedPatientFiles", filesList.file[0]);
        let selectedCategory= filesList.selectedCategory
        if (!authenticationService.currentUserValue)
            return;
        let requestconfig = {
            headers: {
                "Content-Type": "multipart/form-data" ,
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${filesList.UserStorageID}/${filesList.RequestID}/selectedCategory/${selectedCategory}/getUploadedFile/${file.name}`,
            formData,
            requestconfig
        );
    },

    getLeumitUploadedFile: async (filesList) => {
        let formData = new FormData()
        let namesArr = []
        filesList.file.map((item,index)=>{
            namesArr.push(filesList.file[index].name)
            formData.append("uploadedPatientFiles"+index, filesList.file[index]);
        })
        const jsonStr = JSON.stringify(namesArr);
        formData.append("body",jsonStr)
        let selectedCategory= filesList.selectedCategory
        if (!authenticationService.currentUserValue)
            return;
        let requestconfig = {
            headers: {
                'Content-Type': 'multipart/form-data;Boundary=---WebKitFormBoundary7MA4YWxkTrZu0gW',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${filesList.UserStorageID}/${filesList.RequestID}/selectedCategory/${selectedCategory}/getLeumitUploadedFile`,
            formData,
            requestconfig
        );
    },
    getMedicalConditions: async (val) => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient.profile.UserStorageID}/getMedicalConditions`,
            val,
            requestconfig
        );
    },
    getAllSymptoms: async (val) => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient.profile.UserStorageID}/getAllSymptoms`,
            val,
            requestconfig
        );
    },

    PatientVisit: async (patient_data,patient_id) => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient_id}/profile`,
            patient_data,
            requestconfig
        );

    },
    editLeumitPatient: async (patient_data,patient_id) => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient_id}/UpdateMyLeumitPatientProfile`,
            patient_data,
            requestconfig
        );

    },

    getPatientById: async (patient_id) => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient_id}/profile`,
            requestconfig
        );
    },
    deletePatient: async (patient_id) => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.delete(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient.profile.UserStorageID}/patients/${patient_id}/profile`,
            requestconfig
        );

    },
    sendMessageToPatients: async (data) => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient.profile.UserStorageID}/patients/sendMessages`,
            data,
            requestconfig
        );

    },
    getAllCompletedPatients: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient.profile.UserStorageID}/getallpatients?archive=true`,
            requestconfig
        );
    },
    getAllpatients: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;

        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient.profile.UserStorageID}/getAllHCP`,
            requestconfig
        );

    },
    EditHCP: async (hcp_data,HCP_UserStorageID) => {
        if (!authenticationService.currentUserValue)
            return;
        let patient = authenticationService.currentUserValue;

        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return (await axios.post(
            `${Config.globalUrl}/api/v1/webapp/patients/${patient.profile.UserStorageID}/${HCP_UserStorageID}/profile`,
            hcp_data,
            requestconfig
        ));
    },
}


export default patientApi;
